import { fetchAll, fetchFiltered, addAcessory, show, edit } from '@/api/acessories'

const state = {
  all: [],
  isLoading: false,
  acessoryById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const acessory = await show(id)
      commit('setAcessoryById', acessory)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const acessories = await fetchAll()
      commit('setAll', acessories)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const acessories = await fetchFiltered(queriesParams)
      commit('setAll', acessories)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addAcessory(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.acessoryById = null
  },

  setAll (state, acessories) {
    state.all = acessories
  },

  setAcessoryById (state, acessory) {
    state.acessoryById = {
      id: acessory.id,
      name: acessory.name,
      isActive: acessory.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
